import { ToastAlertTypes } from '@genial/components';

export const tableHeadCustomerData = [
  { title: 'Nome', flex: 2 },
  { title: 'CPF/CNPJ' },
  { title: 'Conta' },
  { title: 'Suitability' },
  { title: 'Cadastro' },
  { title: 'Hashtag' },
  { title: 'Saldo disponível' },
  { title: '' },
];

export const errorBalanceUpdateMessage: [ToastAlertTypes.Type, string, string] = [
  'error',
  'Opa! Algo parece errado.',
  'Ocorreu um erro ao atualizar saldo,\nverifique sua conexão com a internet e\ntente novamente em instantes.',
];

export const errorDuplicateTag: [ToastAlertTypes.Type, string, string] = [
  'error',
  'Opa! Algo parece errado.',
  'Tag duplicada, verifique e tente novamente.',
];

export const successBalanceUpdateMessage: [ToastAlertTypes.Type, string, string] = [
  'success',
  'Tudo certo!',
  'O saldo foi atualizado com sucesso!',
];

export const sucessUpdateProductMessage: [ToastAlertTypes.Type, string, string] = [
  'success',
  'Tudo certo!',
  'O valor foi alterado com sucesso!',
];

export const errorTotalValueProductMessage: [ToastAlertTypes.Type, string, string] = [
  'error',
  'Erro!',
  'O valor máximo foi excedido, o valor deve estar entre zero e 1 milhão!',
];

const confirmItemWarningProps = {
  title: 'Atenção',
  icon: 'Warning',
  iconColor: 'feedback.attention.default',
  confirmText: 'Continuar',
  confirmColor: 'feedback.error.default',
} as const;

export const confirmItemTagWarningData = {
  ...confirmItemWarningProps,
  description:
    'Esta ação modificará todas as tags associadas aos clientes.\nDeseja continuar mesmo assim?',
} as const;

export const confirmCancelOrderWarningProps = {
  ...confirmItemWarningProps,
  description: 'Esta ação irá cancelar a solicitação.\nDeseja continuar mesmo assim?',
};
